import { iotsUtils } from '@bedc/core';

export const Id = iotsUtils.withPrefix('fps-job');
